<ng-container *ngIf="cargando">
  <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:5%">
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_CARGA_INFO' | translate}}</h1>
  </div>
</ng-container>
<ng-container  *ngIf="!cargando">
  <div class="" fxLayout="column" fxLayoutAlign="space-between center">
    <mat-tab-group mat-align-tabs="start" style="width: 100%; background: white;padding-bottom: 60px;">
          <mat-tab label="{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_TITL_TAB1' | translate}}">
            <div class="" style="margin-top:20px;margin-left:20px" fxLayout="row" fxLayoutAlign="space-between center">
                <h1>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_INDIC_1' | translate}} </h1>
                <button mat-raised-button color="primary" (click)="exportTable();" >{{'CONSULTARENCUESTA.BOTON_DESCARGA_EXCEL' | translate }}</button>
            </div>
                <ng-container *ngIf="filtrandoLide">
                  <div fxLayout="column" fxLayoutAlign="space-between center" >
                    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                    <h1>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_FILT_INFO' | translate}}</h1>
                  </div>
                </ng-container>
                <ng-container *ngIf="!filtrandoLide">
                  <div class="" fxLayout="column" >
                    <mat-form-field appearance="outline" fxFlex="100" >
                        <mat-label>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_INDIC_BUSQ' | translate}}</mat-label>
                      <input matInput  [(ngModel)]='busquedaLiaders' (keyup)="applyFilter($event.target.value)">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
          <div class="" fxLayout="row" fxLayoutAlign="space-between start">
            <div class="" fxFlex='90'>
              <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 tableInfo">
                <ng-container matColumnDef="NameUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_1' | translate}}</th>
                  <td mat-cell *matCellDef="let element" class="tamañoLetra lftBrd">{{element.NameUser}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_2' | translate}} </th>
                  <td mat-cell *matCellDef="let element" class="tamañoLetra lftBrd"> {{element.email}} </td>
                </ng-container>
                <ng-container matColumnDef="Area">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_3' | translate}} </th>
                  <td mat-cell *matCellDef="let element" class="tamañoLetra lftBrd"> {{element.Area}} </td>
                </ng-container>

                <ng-container matColumnDef="JobTitle">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_PUEST_LEAD' | translate}}</th>
                  <td mat-cell *matCellDef="let element" class="tamañoLetra lftBrd"> {{element.JobTitle}} </td>
                </ng-container>
                <ng-container matColumnDef="Localidad">
                  <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_EMA_LOCA' | translate}}</th>
                  <td mat-cell *matCellDef="let element" class="tamañoLetra lftBrd"> {{element.Localidad}} </td>
                </ng-container>
                <ng-container matColumnDef="NumberOfEmails">
                  <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_EMA_SEND' | translate}}</th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;" class="lftBrd"> <mat-icon class="tamañoIcon" matBadge="{{element.NumberOfEmails}}" *ngIf="element.NumberOfEmails>0">mark_email_read </mat-icon> </td>
                </ng-container>

                <!-- Checkbox Column -->
                <ng-container matColumnDef="select" >
                  <th mat-header-cell *matHeaderCellDef class="lftBrd">
                    <mat-checkbox (change)="$event ? masterToggle() : null;"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"

                    >
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="lftBrd">
                  <mat-checkbox (click)="$event.stopPropagation(); select2(row)"
                  (change)="$event ? selection.toggle(row) : null; "
                  [checked]="selection.isSelected(row)"

                  >
                </mat-checkbox>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>
          <mat-paginator class="tamaño" style-paginator  showFirstLastButtons [showTotalPages]="20" [pageSizeOptions]="[20, 50, 100, 500]" [length]="dataSource.data.length"></mat-paginator>
            </div>
            <div class="" fxFlex='10'>
              <button mat-fab matTooltip="{{'LEADER_GO.SECCION_SELECT_LEADER.BTN_SEND_MAIL' | translate}}" matTooltipPosition="left" class="btnPosition" color="primary" (click)="enviarCorreosLideres()">
              <mat-icon>send</mat-icon>
            </button>
            </div>

          </div>
        </div>
          </ng-container>
        </mat-tab>
    </mat-tab-group>

</div>
<!-- <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">



  <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
  matTooltip="{{'CERTIFICAR.IDIOMAS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
  >
  <mat-icon>done</mat-icon>
</button>
<button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
  {{'CERTIFICAR.IDIOMAS.STATUS.DONE' | translate}}
  <mat-icon class="ml-20">done</mat-icon>
</button>
<button *ngIf="pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearIdiomas()" mat-fab aria-label=""
  matTooltip="{{'CERTIFICAR.IDIOMAS.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
  >
  <mat-icon>lock_open</mat-icon>
</button>

<button *ngIf="!pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearIdiomas()" mat-raised-button class="reopen mr-20">
  {{'CERTIFICAR.IDIOMAS.STATUS.UNLOCK' | translate}}
</button>

</div> -->
</ng-container>
